import { c as _c } from "react/compiler-runtime";
import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { LoadingSpinner } from '@onefootprint/ui';
import { useEffect, useRef } from 'react';
import OnboardingListItem from './onboarding-list-item';
type OnboardingListProps = {
  onboardings: EntityOnboarding[];
  selectedId: string;
  onSelect: (id: string) => void;
  onLoadMore: () => void;
  hasMore: boolean;
  isLoadingMore: boolean;
};
const LOAD_MORE_THRESHOLD = 0.9;
const OnboardingList = t0 => {
  const $ = _c(18);
  const {
    onboardings,
    selectedId,
    onSelect,
    onLoadMore,
    hasMore,
    isLoadingMore
  } = t0;
  const listRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Map();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const itemRefs = useRef(t1);
  let t2;
  if ($[1] !== hasMore || $[2] !== isLoadingMore || $[3] !== onLoadMore) {
    t2 = () => {
      const list = listRef.current;
      if (!list || !hasMore || isLoadingMore) {
        return;
      }
      if ((list.scrollTop + list.clientHeight) / list.scrollHeight >= LOAD_MORE_THRESHOLD) {
        onLoadMore();
      }
    };
    $[1] = hasMore;
    $[2] = isLoadingMore;
    $[3] = onLoadMore;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleScroll = t2;
  let t3;
  let t4;
  if ($[5] !== selectedId) {
    t3 = () => {
      const list_0 = listRef.current;
      const item = itemRefs.current.get(selectedId);
      if (!list_0 || !item) {
        return;
      }
      const isVisible = item.offsetTop >= list_0.scrollTop && item.offsetTop + item.offsetHeight <= list_0.scrollTop + list_0.clientHeight;
      if (!isVisible) {
        list_0.scrollTo({
          top: item.offsetTop - (list_0.clientHeight - item.offsetHeight) / 2,
          behavior: "smooth"
        });
      }
    };
    t4 = [selectedId];
    $[5] = selectedId;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== onSelect || $[9] !== onboardings || $[10] !== selectedId) {
    t5 = onboardings.map(onboarding => <OnboardingListItem key={onboarding.id} ref={node => {
      if (node) {
        itemRefs.current.set(onboarding.id, node);
      } else {
        itemRefs.current.delete(onboarding.id);
      }
    }} onboarding={onboarding} isSelected={onboarding.id === selectedId} onClick={() => onSelect(onboarding.id)} />);
    $[8] = onSelect;
    $[9] = onboardings;
    $[10] = selectedId;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isLoadingMore) {
    t6 = isLoadingMore && <div className="flex justify-center py-2"><LoadingSpinner size="compact" /></div>;
    $[12] = isLoadingMore;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== handleScroll || $[15] !== t5 || $[16] !== t6) {
    t7 = <div ref={listRef} className="relative flex flex-col gap-1 w-full max-h-56 pr-2 overflow-auto md:w-64 md:shrink-0 md:h-full md:max-h-none" onScroll={handleScroll}>{t5}{t6}</div>;
    $[14] = handleScroll;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default OnboardingList;